import React, { PureComponent } from 'react';
import { ssoLoginActions } from '../reducer/sso-login-reducer';
import { MouseCatcherContainer as MouseCatcher } from '../../app/util/MouseCatcher';
import { connect } from 'react-redux';

/*
    MobileSsoLoginSuccess page is a simple wrapper to clear some state in MobileSsoLogin and
    redirect to launchpad after successful SSO login. Nothing gets rendered here.
 */
//*********************************************
export class MobileSsoLoginSuccess extends PureComponent {
  constructor(props) {
    super(props);

    // reset state in ssomobilelogin
    this.props.setSsoLoginAttemptPending(false);
  }

  render = () => {
    return <MouseCatcher />;
  };
}

MobileSsoLoginSuccess.propTypes = {};

const mapStateToProps = (state, ownprops) => ({});

const wrapActions = { setSsoLoginAttemptPending: ssoLoginActions.setSsoLoginAttemptPending };

export const MobileSsoLoginSuccessContainer = connect(
  mapStateToProps,
  wrapActions
)(MobileSsoLoginSuccess);



// WEBPACK FOOTER //
// ./src/modules/login/components/MobileSsoLoginSuccess.jsx